import { useState, useEffect } from "react";
import { Dumbbell } from "lucide-react";
import { PROGRAM_ICON_MAP } from "@/lib/program-icons";

interface ProgramImageProps {
  image: string;
  title: string;
  className?: string;
  iconSize?: string;
}

export function ProgramImage({ image, title, className = "", iconSize = "w-6 h-6" }: ProgramImageProps) {
  const [hasError, setHasError] = useState(false);
  
  // Reset error state when image prop changes
  useEffect(() => {
    setHasError(false);
  }, [image]);
  const iconConfig = PROGRAM_ICON_MAP[image];
  
  // Icon-based image (dumbbell, flame, etc.)
  if (iconConfig) {
    const IconComponent = iconConfig.icon;
    return (
      <div className={`bg-gradient-to-br ${iconConfig.color} flex items-center justify-center ${className}`}>
        <IconComponent className={`${iconSize} text-white`} />
      </div>
    );
  }
  
  // Fallback to dumbbell icon if no image or on error
  if (!image || image === '' || hasError) {
    return (
      <div className={`bg-gradient-to-br from-primary/20 to-primary/40 flex items-center justify-center ${className}`}>
        <Dumbbell className={`${iconSize} text-primary`} />
      </div>
    );
  }
  
  // URL-based image (uploaded or external)
  return (
    <div className={`overflow-hidden ${className}`}>
      <img 
        src={image} 
        alt={title}
        loading="lazy"
        decoding="async"
        className="w-full h-full object-cover"
        onError={() => setHasError(true)}
      />
    </div>
  );
}
